import { render } from "./WrestlingPage.vue?vue&type=template&id=ad4fe150"
import script from "./WrestlingPage.vue?vue&type=script&lang=js"
export * from "./WrestlingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__